import { FC } from "react";

import { TriangleDownIcon } from "@chakra-ui/icons";
import { Menu, MenuList, MenuButton, MenuItem, useMultiStyleConfig } from "@chakra-ui/react";

import { Typography } from "@components/common";

import { TDropdownProps } from "./types";
import getOptionValues from "./utils/getOptionValues";

const Dropdown: FC<TDropdownProps> = ({ id, options, value, href = "/", ariaLabel = '' }) => {
  const styles = useMultiStyleConfig("Dropdown", {});
  const { selectedOption, remainingOptions } = getOptionValues(options, value);

  return (
    <Menu offset={[0, 0]} id={id}>
      <MenuButton sx={styles.select} aria-label={ariaLabel}>
        {selectedOption.label}
        <TriangleDownIcon height="0.375rem" width="0.5rem" />
      </MenuButton>
      <MenuList sx={styles.menu}>
        {remainingOptions.map(({ label, value: optionValue }) => (
          <MenuItem
            key={`dropdown-${label}-${value}`}
            sx={styles.languageItem}
            as='a'
            name={`language-mobile-select-${optionValue}`}
            href={`/${optionValue}${href}`}
            target="_self"
            tabIndex={-1}
          >
            <Typography type="tiny">{label}</Typography>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default Dropdown;